<template>
  <div class="ws-modal">
    <form
      class="ws-modal__form"
      @submit.prevent="submit"
    >
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span v-text="$t('Изменение данных ОО')"></span>
        </h2>
      </header>
      <div class="ws-modal__content">
        <div class="columns is-multiline">
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('Полное наименование')"
              :type="{'is-danger': errors.has('title')}"
              :message="errors.first('title')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.title.translate.ru"
                v-validate="{ required: true }"
                name="title"
              />
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('Краткое наименование')"
              :type="{'is-danger': errors.has('short_title')}"
              :message="errors.first('short_title')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.short_title.translate.ru"
                v-validate="{ required: true }"
                name="short_title"
              />
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('Адрес организации')"
              :type="{'is-danger': errors.has('address')}"
              :message="errors.first('address')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.address.address.translate.ru"
                v-validate="{ required: true }"
                name="address"
              />
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('ИНН')"
              :type="{'is-danger': errors.has('inn')}"
              :message="errors.first('inn')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.inn"
                v-validate="{ required: true, digits:10 }"
                name="inn"
              />
            </b-field>
          </div>
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('КПП')"
              :type="{'is-danger': errors.has('kpp')}"
              :message="errors.first('kpp')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.kpp"
                v-validate="{ required: true, digits:9 }"
                name="kpp"
              />
            </b-field>
          </div>
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('ОГРН')"
              :type="{'is-danger': errors.has('ogrn')}"
              :message="errors.first('ogrn')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.ogrn"
                v-validate="{ required: true }"
                name="ogrn"
              />
            </b-field>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column">
            <b-field
              class="ws-field is-required"
              :label="$t('Комментарий')"
              :type="{'is-danger': errors.has('reason')}"
              :message="errors.first('reason')"
            >
              <b-input
                class="ws-field__control"
                v-model="item.reason"
                v-validate="{ required: true }"
                name="reason"
              />
            </b-field>
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <button type="submit" :disabled="isLoading" class="ws-button button is-large is-primary is-fullwidth">
                <span
                    class="is-size-4 has-text-weight-bold"
                    v-text="$t('Создать обращение')"
                ></span>
            </button>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button
        class="ws-button button is-text"
        @click="close"
      >
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
const createFormData = () => ({
  title: { translate: {} },
  short_title: { translate: {} },
  category: '',
  license: {
    number: null,
    issue: null
  },
  inn: '',
  kpp: '',
  based_at: null,
  licensed_at: null,
  expired_at: null,
  address: { address: { translate: {} } },
  branch: [],
  educational_program: [],
  curators: [],
  de_centers: [],
  base_guid: null,
  // Тип организации
  org_type: '',
  // Тип ОО
  institution_org_type: '',
  // Форма неком. орг.
  non_profit_org_form: '',
  // Структура ОО
  org_structur: '',
  visible: true,
  ogrn: '',
  registration_date: null,
  actuality_date: null,
  liquidation_date: null
})

export default {
  name: 'WsOrgsUpdateTicket',
  props: {
    data: {
      type: Object,
      default: createFormData()
    }
  },
  data () {
    return {
      item: createFormData(),
      isLoading: false
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler (value) {
        this.item = { ...this.data }
      }
    }
  },
  methods: {
    ...mapActions('api/refbook/education/institution', ['updateOrgs']),
    async submit () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            this.isLoading = true
            await this.updateOrgs(this.item)
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Обращение создано, на вашу почту придет уведомление с номером заявки'
            })
            this.$emit('fetch')
            this.$parent.close()
            this.isLoading = false
          } catch (err) {
            this.$buefy.toast.open({
              message: this.$t(err || `Что-то пошло не так. Попробуйте еще раз`),
              type: 'is-danger'
            })
            this.isLoading = false
          }
        }
      })
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
<style lang="scss" scoped>
.ws-modal {
  max-width: 100%;
}
</style>
